export default {

  trim (str) {
    return str.trim()
  },

  isEmpty (str) {
    return str === ''
  },

  isZero (num) {
    return num === 0 || num === '0'
  },

  isNull (val) {
    return val === null
  },

  isUndefined (val) {
    return val === undefined
  },

  isEmail (email) {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
  },

  equals (str1, str2) {
    return str1 === str2
  },

  isCode (code) {
    return /^\d{6}$/.test(code)
  },

  isAlpha (str) {
    if (str === '') return true
    return /^[A-Za-zÁÉÍÓÚáéíóúñÑ._ ]+$/g.test(str)
  },

  isDDMMYYYY (str) {
    if (str === '') return true

    let split = str.split('/')
    const dd = parseInt(split[0])
    const mm = parseInt(split[1])
    const yyyy = parseInt(split[2])

    if ((isNaN(dd) || dd < 1 || dd > 31) ||
      (isNaN(mm) || mm < 1 || mm > 12) ||
      (isNaN(yyyy) || yyyy < 1900 || yyyy > (new Date()).getFullYear())) {
      return false
    }

    return true
  },

  isCodigoArea (str) {
    if (str === '' || str === null || str === undefined) return true
    return /^\d{2,4}$/.test(str)
  },

  isNumeroTelefono (str) {
    if (str === '' || str === null || str === undefined) return true
    return /^\d{6,8}$/.test(str)
  }

}
